import React, { Component } from 'react';
import { DataTable } from '../../../DataTable/DataTable';
import { convertUTCToLocalDateTime } from '../../../../helpers/GlobalFunctions';
import { deviceMessages } from '../../../../helpers/messages';

class SDAFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSDABlock: false
        }
    }

    /**
     * @description Function to show SDA upload modal
     * @memberof SDAFiles
     */
    handleUploadModalOpen = () => {
        this.setState({ showSDABlock: true });
        this.props.toggleUploadModal();
    }

    /**
     * @description Function to return Show More/Less text html
     * @memberof SDAFiles
     */
    getShowTextTemplate = (text) => {
        return (
            <div className="showText text-left mt-2">
                <p className="m-0 btn-show-hide d-inline-block fs-8-rem cursor-pointer" data-testid="sda-panel" id="sda-panel" onClick={(e) => this.togglePanels(e)}>Show {text}</p>
            </div>
        )
    }

    /**
     * @description Function to toggle show and hide password/key panels
     * @memberof SDAFiles
     */
    togglePanels = (event) => {
        event.preventDefault();
        this.setState(prevState => {
            return {
                showSDABlock: !prevState.showSDABlock
            }
        })
    }

    /* istanbul ignore next  */
    render() {
        const { sdaList, sdaDownloadError, showUploadSuccessMsg, latestFileContent } = this.props;
        const { showSDABlock } = this.state;
        const columns = [
            {
                Header: 'Filename',
                accessor: 'filename',
                Cell: ({ row }) => (<span>{row.original.filename ? row.original.filename : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Upload Date',
                accessor: 'uploadedDate',
                Cell: ({ row }) => (<span>{row.original.uploadedDate ? convertUTCToLocalDateTime(row.original.uploadedDate) : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: ' ',
                sdaFileAction: true
            }
        ]
        return (
            <>
                <div className="row">
                    <div className="col-8">
                        <h2 className="card-title pb-0">SDA Files</h2>
                        {sdaDownloadError && <div className="text-danger">{sdaDownloadError}</div>}
                    </div>
                    <div className="col-4 text-end">
                        <button type="button" className="btn btn-primary" data-testid="uploadSdaFile" onClick={this.handleUploadModalOpen}>Upload</button>
                    </div>
                </div>
                {showSDABlock ?
                    <div className="row mt-2">
                        <div className="col-sm-12 mb-2">
                            {showUploadSuccessMsg ? <div className="success-msg"><p className="m-0">{deviceMessages.fileUploadSuccess}</p></div> : ''}
                            <div className="table-wrap">
                                <DataTable
                                    listType="sda-list"
                                    showPagination={false}
                                    disableColmSort={true}
                                    columns={columns}
                                    data={sdaList}
                                    latestFileContent={latestFileContent}
                                />
                            </div>
                        </div>
                        {this.getShowTextTemplate('Less')}
                    </div> :
                    this.getShowTextTemplate('More')}
            </>
        );
    }
}

export default SDAFiles;
